import { memo } from 'react';
import { SkeletonGradient } from 'conversations-skeleton-state/components/SkeletonGradient';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MetadataEditorSkeleton = /*#__PURE__*/memo(() => /*#__PURE__*/_jsxs(Flex, {
  inlineSize: "100%",
  blockSize: "49px",
  alignItems: "center",
  overflow: "hidden",
  "data-loading": "true",
  children: [/*#__PURE__*/_jsx(SkeletonGradient, {}), /*#__PURE__*/_jsx(View, {
    position: "absolute",
    blockSize: "24px",
    inlineSize: "25%",
    backgroundColor: "fill-surface-default",
    marginInlineStart: "400"
  })]
}));
MetadataEditorSkeleton.displayName = 'MetadataEditorSkeleton';
export default MetadataEditorSkeleton;